"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_81_12_1 = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const ManagedConfigurationType_1 = require("../ManagedConfigurationType");
/**
 * Migrate to 81.12.1
 *
 * Copy `Remove wrong Mounting on Zugentlastung`
 */
const migration_81_12_1 = (json) => {
    var _a;
    if (json.ManagedConfigurationType !== ManagedConfigurationType_1.ManagedConfigurationType.IQuote) {
        return json;
    }
    (_a = json.Zugentlastungen) === null || _a === void 0 ? void 0 : _a.forEach((ze) => {
        switch (ze.Mounting) {
            case echain_shared_articles_1.ZugentlastungMounting.beidseitig:
            case echain_shared_articles_1.ZugentlastungMounting.festpunkt:
            case echain_shared_articles_1.ZugentlastungMounting.mitnehmer:
            case undefined:
                // this is valid
                return;
            default:
                ze.Mounting = undefined;
        }
    });
    return json;
};
exports.migration_81_12_1 = migration_81_12_1;
//# sourceMappingURL=migration_81_12_1.js.map